import { createReducer } from 'modules/app-core/redux-utils'
import t from './actionTypes'

// initialState
const initialState = {
  messageList: [],
  message: {},
  isListView: true,
}

export default createReducer(initialState, {
  [t.LOAD_MESSAGE_LIST]: (state, payload) =>
    Object.assign({}, state, {
      messageList: payload,
    }),
  [t.LOAD_MESSAGE]: (state, payload) =>
    Object.assign({}, state, {
      message: payload,
      isListView: false,
    }),
  [t.TOGGLE_VIEW]: (state) =>
    Object.assign({}, state, {
      isListView: !state.isListView,
    }),
})
